import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({

  root: {
    display: 'flex',
    height: 200,
    borderRadius: '13px',
    minWidth: '280px'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    // flex: '1 0 auto',
  },
  cover: {
    width: 151,
  },
  conteiner: {
    // minWidth: '300px',
    borderRadius: '13px',
  }
}));




const Wrapper = ({ children, link }) => {
  const isExternal = link.startsWith('http');
  
  if (isExternal) {
    return (
      <a 
        href={link} 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{ textDecoration: 'none' }}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={link} style={{ textDecoration: 'none' }}>
      {children}
    </Link>
  );
};

export default function ImgMediaCard({text,imgPath,title,link}) {
  const classes = useStyles();

  return (
    <div
      className={classes.conteiner}>
      <Wrapper link={link}>
          <Card className={classes.root}>
            <CardMedia
              component="img"
              className={classes.cover}
              image={imgPath}
              alt={title}
              height="240"
            />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography gutterBottom variant="h5" component="h2">
                {title}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                {text}
              </Typography>
            </CardContent>
          </div>
        </Card>
      </Wrapper>
    </div>
  );
}
